import React from "react";
import Popup from "reactjs-popup";
import { Project, ProjectChat } from "../components";
import NewProjectForm from "../components/Form/Projects/NewProjectForm";
import OXCancel from "../components/OXCancel";
import { Wrapper } from "../HOC";
import { Line } from "rc-progress";
import { useDispatch } from "react-redux";
import { useProject } from "../context/ProjectContext";
import { useEffect } from "react";
import { closeModal, openModal } from "../redux/modal/modalRedux";


export const overlayStyle = { background: "rgba(0,0,0,0)" };
const Projects = () => {
  const dispatch = useDispatch();
  const { loader } = useProject();

  useEffect(() => {
    if (loader) {
      dispatch(openModal());
    } else {
      dispatch(closeModal());
    }
  }, [dispatch, loader]);

  return (
    <Wrapper>
      <div className="w-full flex justify-between h-[calc(100vh-110px)] overflow-hidden">
        <div className="w-[45%] overflow-auto scrollbar-hide">
          <div className="flex gap-4 items-center">
            <p className="text-[#1A1D4D] font-black text-[24px]">My Projects</p>
            <Popup
              trigger={
                <button className="w-[200px] py-3 bg-primary rounded text-white text-base">
                  + New Project
                </button>
              }
              position="right center"
              modal
              closeOnDocumentClick={true}
              nested
              {...{ overlayStyle }}
              contentStyle={{
                borderRadius: "12px",
                border: 0,
                backgroundColor: "white",
                width: "fit-content",
                fontSize: "0.8rem",
                maxHeight: "95%",
                overflow: "auto",
                position: "absolute",
                bottom: 50,
                left: 60,
              }}
            >
              {(close) => (
                <div className="px-5 py-10 shadow-3xl animate-slide-in">
                  <p className="text-[18px] text-center">
                    Do you want to add new project?
                  </p>
                  <div className="flex gap-4">
                    <Popup
                      trigger={
                        <button className="w-[200px]  h-[50px] bg-primary rounded mt-12 text-white text-base font-semibold">
                          Yes
                        </button>
                      }
                      position="right center"
                      modal
                      closeOnDocumentClick={false}
                      nested
                      contentStyle={{
                        borderRadius: "12px",
                        backgroundColor: "white",
                        width: "fit-content",
                        fontSize: "0.8rem",
                        maxHeight: "95%",
                        overflow: "auto",
                      }}
                    >
                      <>
                        <OXCancel close={close} />
                        <NewProjectForm close={close} />
                      </>
                    </Popup>
                    <button
                      onClick={close}
                      className="w-[200px] h-[50px] border border-primary rounded mt-12 text-primary text-base font-semibold"
                    >
                      No
                    </button>
                  </div>
                </div>
              )}
            </Popup>
          </div>
          <Project />
        </div>

        <div className="w-[55%] h-full">
          <div className="pl-64">
            <p className="font-semibold pb-1">Construction Details</p>
            <Line
              percent={48}
              strokeWidth={4}
              trailWidth={4}
              strokeColor="#fac213"
            />
            <div className="flex justify-between items-center pt-1">
              <p></p>
              {/* <Line percent={percentageUsed} strokeWidth={4} trailWidth={4} strokeColor="#0086E6" /> */}
              <p className="text-xs text-primary">48%</p>
              <p className="text-xs">100%</p>
            </div>
          </div>

          <ProjectChat />
        </div>
      </div>
    </Wrapper>
  );
};

export default Projects;
